import { Injectable } from "@angular/core";
import { Store } from "@ngrx/store";
import { map, Observable } from "rxjs";
import { loginFeatureName, LoginState } from "../../pages/login-page/login-page-data/store/login.reducer";
import { selectLoginData } from "../../pages/login-page/login-page-data/store/login.selectors";
import { UserPermissions } from "../../pages/login-page/login-page-data/login.types";

@Injectable({
  providedIn: "root",
})
export class PermissionsService {
  constructor(private store: Store<{ [loginFeatureName]: LoginState }>) {}

  getUserPermissions(): Observable<UserPermissions | undefined> {
    return this.store.select(selectLoginData).pipe(map((userData) => userData.permissions));
  }

  hasPermission(resource: keyof UserPermissions): Observable<boolean> {
    return this.store.select(selectLoginData).pipe(
      map((userData) => {
        return userData.permissions?.[resource] || false;
      }),
    );
  }
}
